import { LitElement, html, nothing } from 'lit';

export default class CountryProvinceSelector extends LitElement {  
  
  // Avoid shadow DOM
  createRenderRoot() {
    return this;
  }
  
  static get properties() {
    return {
      tags: { type: String },
      countriesMap: { type: Object, reflect: true },
      selectedCountry: { type: String, reflect: true },
      provinces: { type: Array },
      selectedProvince: { type: String, reflect: true },
      inputType: { type: String },

      countryInputName: { type: String },
      provinceInputName: { type: String },
    };
  }
  
  constructor() {
    super();
    this.countriesMap = {};
    this.selectedCountry = '';
    this.provinces = [];
    this.selectedProvince = '';
    this.inputType = 'select';
  }

  connectedCallback() {
    super.connectedCallback();
    
    if (Object.keys(this.countriesMap).length) {
      return;
    }
    
    const countriesMap = {};
    
    const options = Array.from(this.children);
    for (const option of options) {

      const country = option.value;
      
      if (!country || country === '---') {
        continue;
      }

      const provinces = JSON.parse(option.dataset.provinces);
      countriesMap[country] = provinces.map(province => province?.[province.length - 1] || province).map(province => province.replace('&#39;', `'`));
    }
    
    this.countriesMap = countriesMap;
    console.log('countriesMap', countriesMap);

    this.innerHTML = ''; // Clear initial markup

    // If a country is selected on load, set the provinces
    if (this.selectedCountry && this.countriesMap[this.selectedCountry]) {
      this.provinces = this.countriesMap[this.selectedCountry];
    }
  }
  
  handleCountryChange(e) {
    this.selectedCountry = e.target.value;
    this.selectedProvince = ''; // Reset province selection
    
    if (this.selectedCountry && this.countriesMap[this.selectedCountry]) {
      this.provinces = this.countriesMap[this.selectedCountry];
    } else {
      this.provinces = [];
    }
    
    // Trigger re-render
    this.requestUpdate();
  }
  
  handleProvinceChange(e) {
    this.selectedProvince = e.target.value;
  }

  renderSelect() {
    const countries = Object.keys(this.countriesMap);
    return html`
      <select 
        name="${ this.countryInputName || 'country' }" 
        @change="${ this.handleCountryChange }"
        .value="${ this.selectedCountry }"
      >
        ${ countries.map(country => 
          html`<option value="${ country }" ?selected="${ this.selectedCountry === country }">
            ${ country }
          </option>`
        ) }
      </select>

      ${ (!this.selectedCountry || this.provinces.length > 0) ? html`
        <select 
          name="${ this.provinceInputName || 'province' }" 
          @change="${ this.handleProvinceChange }"
          .value="${ this.selectedProvince }"
          ?disabled="${ !this.selectedCountry || this.provinces.length === 0 }"
        >
          ${ this.provinces.map(province => 
            html`<option value="${ province }" ?selected="${ this.selectedProvince === province }">
              ${ province }
            </option>`
          ) }
        </select>
      ` : nothing }
    `;
  }
  
  renderFloatSelect() {
    const countries = Object.keys(this.countriesMap);
    return html`
      <float-select 
        name="${ this.countryInputName || 'country' }" 
        @change="${ this.handleCountryChange }"
        .value="${ this.selectedCountry }"
        .options=${[
          { value: '', label: 'Select Country', hidden: true },
          ...countries.map(country => ({ value: country, label: country, selected: this.selectedCountry === country }))
        ]}
      >
      </float-select>

      ${ (!this.selectedCountry || this.provinces.length > 0) ? html`
        <float-select 
          name="${ this.provinceInputName || 'province' }" 
          @change="${ this.handleProvinceChange }"
          .value="${ this.selectedProvince }"
          ?disabled="${ !this.selectedCountry || this.provinces.length === 0 }"
          .options=${[
            { value: '', label: 'Select Province', hidden: true },
            ...this.provinces.map(province => ({ value: province, label: province, selected: this.selectedProvince === province }))
          ]}
        >
        </float-select>
      ` : nothing }
    `;
  }

  render() {    
    return html`
      ${ this.inputType === 'float-select' ? this.renderFloatSelect() : this.renderSelect() }
    `;
  }
}
      
customElements.define('country-province-selector', CountryProvinceSelector);